import actions from "./actions";

const initState = {
  lessons: [],
  lessonDetail: null,
  loading: false,
  errors: null,
  libraries: null,
  myLibraries: null, // added since it's used in FETCH_MY_LIBRARY_SUCCESS
};

export default function userReducer(state = initState, action) {
  switch (action.type) {
    case actions.FETCH_LESSON_DETAILS:
      return {
        ...state,
        lessonDetail: null,
        loading: true,
        errors: null,
      };

    case actions.FETCH_LESSON_DETAILS_SUCCESS:
      return {
        ...state,
        lessonDetail: action.data || null,
        loading: false,
      };

    case actions.FETCH_LESSON_DETAILS_ERROR:
      return {
        ...state,
        lessonDetail: null,
        loading: false,
      };

    case actions.FETCH_LESSONS:
      return {
        ...state,
        lessons: [],
        loading: true,
        errors: null,
      };

    case actions.FETCH_LESSONS_SUCCESS:
      return {
        ...state,
        lessons: action.data || [],
        loading: false,
      };

    case actions.SAVE_LESSON:
      return {
        ...state,
        loading: true,
        errors: null,
      };

    case actions.SAVE_LESSON_SUCCESS:
      return {
        ...state,
        loading: false,
        lessonDetail: action.data || null,
      };

    case actions.SAVE_LESSON_ERROR:
      return {
        ...state,
        loading: false,
        errors: action.errors,
      };

    case actions.DELETE_LESSON:
      return {
        ...state,
        loading: true,
        errors: null,
      };

    case actions.DELETE_LESSON_SUCCESS:
      return {
        ...state,
        loading: false,
        lessonDetail: action.data || null,
      };

    case actions.DELETE_LESSON_ERROR:
      return {
        ...state,
        loading: false,
        errors: action.errors,
      };

    case actions.FETCH_LIBRARY:
    case actions.FETCH_MY_LIBRARY:
    case actions.FILE_UPLOAD:
      return {
        ...state,
        loading: true,
        errors: null,
      };

    case actions.FETCH_LIBRARY_SUCCESS:
      return {
        ...state,
        loading: false,
        libraries: action.data,
      };

    case actions.FETCH_MY_LIBRARY_SUCCESS:
      return {
        ...state,
        loading: false,
        myLibraries: action.data,
      };

    case actions.FILE_UPLOAD_SUCCESS:
    case actions.FILE_UPLOAD_ERROR:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
}
